module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_11-4440dfde3f232420b2d30142f1053165.png";